import { Skeleton } from '@mui/lab';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react';

type SkeletonDataGridProps = {
  rowNumber?: number;
};
export const SkeletonDatagrid = ({ rowNumber }: SkeletonDataGridProps) => {
  return (
    <DataGrid
      className={'-datatable'}
      sx={{ color: 'white' }}
      isRowSelectable={() => false}
      disableRowSelectionOnClick={true}
      disableColumnFilter
      disableColumnMenu
      disableColumnSelector
      disableDensitySelector
      disableEval
      disableVirtualization
      hideFooter
      rows={Array.from({ length: rowNumber ?? 10 }).map((_, index) => ({ id: index }))} // 5 rows skeleton
      columns={[
        {
          field: 'id',
          headerName: '',
          renderCell: () => <Skeleton animation="wave" height={'100%'} width="100%" />,
        },
      ]}
    />
  );
};
